import React, { useEffect, useState } from "react";
import "./hydrafacial.css";
import { useNavigate, Link, useLocation } from "react-router-dom";
import heroImage from "../../../assets/images/ad-laserhairremoval.jpg";
import heroImage1 from "../../../assets/images/ad-laserhairremoval1.jpg";
import favicon from "../../../assets/images/favicon.ico";

import deepCleansingIcon from "../../../assets/images/deep-cleansing.png";
import enhancedHydrationIcon from "../../../assets/images/enhanced-hydration.png";
import skinRenewalIcon from "../../../assets/images/skin-renewal.png";
import nonInvasiveIcon from "../../../assets/images/non-invasive.png";

// Import PNG icons for navigation treatments
import hydrafacialIcon from "../../../assets/images/botox.png";
import acneIcon from "../../../assets/images/navacne.png";
import skinBrighteningIcon from "../../../assets/images/skin-brightening.png";
import antiAgeingIcon from "../../../assets/images/anti-ageing.png";
import youthIcon from "../../../assets/images/youth.png";
import prpFaceIcon from "../../../assets/images/prpface.png";
import co2FacialIcon from "../../../assets/images/co2.png";
import acneScarIcon from "../../../assets/images/acnescar.png";
import moleBirthMarkIcon from "../../../assets/images/wart.png";
import tattoRemovalIcon from "../../../assets/images/tattoo.png";
import wartsRemovalIcon from "../../../assets/images/blackhead.png";
import antiAgeingLaserIcon from "../../../assets/images/laser.png";
import laserHairRemovalIcon from "../../../assets/images/laserHairRemoval.png";

const treatments = [
  { name: "ADVANCED HYDRAFACIAL" },
  { name: "ACNE" },
  { name: "ANTI AGEING" },
  { name: "YOUTH" },
  { name: "PRP FACE" },
  { name: "CO2 FACIAL" },
  { name: "ACNE SCAR" },
  { name: "MOLE & BIRTH MARK REMOVAL" },
  { name: "SKIN BRIGHTENING" },
  { name: "TATTO REMOVAL" },
  { name: "WARTS REMOVAL" },
  { name: "ANTI AGEING LASER" },
  { name: "LASER HAIR REMOVAL" },
];

// Mapping treatment names to their PNG icons
const treatmentIconPNGMap = {
  "ADVANCED HYDRAFACIAL": hydrafacialIcon,
  "ACNE": acneIcon,
  "SKIN BRIGHTENING": skinBrighteningIcon,
  "ANTI AGEING": antiAgeingIcon,
  YOUTH: youthIcon,
  "PRP FACE": prpFaceIcon,
  "CO2 FACIAL": co2FacialIcon,
  "ACNE SCAR": acneScarIcon,
  "MOLE & BIRTH MARK REMOVAL": moleBirthMarkIcon,
  "TATTO REMOVAL": tattoRemovalIcon,
  "WARTS REMOVAL": wartsRemovalIcon,
  "ANTI AGEING LASER": antiAgeingLaserIcon,
  "LASER HAIR REMOVAL": laserHairRemovalIcon,
};

// Mapping treatment names to their URLs with "advanced" prefix
const treatmentUrlMap = {
  "ADVANCED HYDRAFACIAL": "/advanced-hydrafacial-treatment",
  "ACNE": "/advanced-acne-treatment",
  "ANTI AGEING": "/advanced-anti-ageing-treatment",
  "YOUTH": "/advanced-youth-treatment",
  "PRP FACE": "/advanced-prp-face-treatment",
  "CO2 FACIAL": "/advanced-co2-facial-treatment",
  "ACNE SCAR": "/advanced-acne-scar-treatment",
  "MOLE & BIRTH MARK REMOVAL": "/advanced-mole-birth-mark-removal-treatment",
  "SKIN BRIGHTENING": "/advanced-skin-brightening-treatment",
  "TATTO REMOVAL": "/advanced-tatto-removal-treatment",
  "WARTS REMOVAL": "/advanced-warts-removal-treatment",
  "ANTI AGEING LASER": "/advanced-anti-ageing-laser-treatment",
  "LASER HAIR REMOVAL": "/advanced-laser-hair-removal-treatment",
};

// Location data for SEO purposes only
const locations = {
  tambaram: {
    name: "Tambaram",
    address: "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Tambaram, Chennai, Tamil Nadu 600045",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Chromepet, Pallavaram, Perungalathur",
    popularServices: [
      "Full Body Laser Hair Removal",
      "Diode Laser Hair Removal",
      "Permanent Hair Reduction",
      "Painless Laser Hair Removal"
    ],
    specialties: "Laser Hair Removal & Skin Treatment",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Tambaram+Chennai"
  },
  valasaravakkam: {
    name: "Valasaravakkam",
    address: "48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Porur, Alwarthirunagar, Virugambakkam",
    popularServices: [
      "Facial Laser Hair Removal",
      "Bikini Laser Hair Removal",
      "Underarm Laser Hair Removal",
      "Legs Laser Hair Removal"
    ],
    specialties: "Laser Hair Removal & Skin Care",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Valasaravakkam+Chennai"
  },
  gerugambakkam: {
    name: "Gerugambakkam",
    address: "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Kundrathur, Mangadu, Poonamallee",
    popularServices: [
      "Laser Hair Removal for Men",
      "Laser Hair Removal for Women",
      "Safe Laser Hair Removal",
      "Effective Laser Hair Removal"
    ],
    specialties: "Complete Laser Hair Removal Solutions",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Gerugambakkam+Chennai"
  },
  jayanagar: {
    name: "Jayanagar Bangalore",
    address: "Jayanagar, Bengaluru, Karnataka 560069",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh",
    popularServices: [
      "Advanced Laser Hair Removal",
      "Laser Hair Removal for Body",
      "Laser Hair Removal for Face",
      "Long Lasting Hair Removal"
    ],
    specialties: "Advanced Laser Hair Removal & Dermatology Treatments",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Jayanagar+Bangalore"
  }
};

// Define the gallery images
const images = [
  { src: "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?q=80", alt: "Before and After Laser Hair Removal Results" },
  { src: "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?q=80", alt: "Laser Hair Removal Procedure Close-Up" },
  { src: "https://images.unsplash.com/photo-1606206522398-de3bd05b1615?q=80", alt: "Advanced Laser Hair Removal Equipment" },
];

// Functions from hydrafacial.jsx
function openModalWithNavigation(
  image,
  setModalImage,
  setIsModalOpen,
  setCurrentImageIndex,
  images
) {
  const index = images.findIndex((img) => img.src === image.src);
  setCurrentImageIndex(index);
  setModalImage(image);
  setIsModalOpen(true);
}

function closeModal(setIsModalOpen, setModalImage) {
  setIsModalOpen(false);
  setModalImage(null);
}

function navigatePrevious(
  e,
  currentImageIndex,
  images,
  setCurrentImageIndex,
  setModalImage
) {
  e.stopPropagation();
  const newIndex = (currentImageIndex - 1 + images.length) % images.length;
  setCurrentImageIndex(newIndex);
  setModalImage(images[newIndex]);
}

function navigateNext(
  e,
  currentImageIndex,
  images,
  setCurrentImageIndex,
  setModalImage
) {
  e.stopPropagation();
  const newIndex = (currentImageIndex + 1) % images.length;
  setCurrentImageIndex(newIndex);
  setModalImage(images[newIndex]);
}

function navigateGalleryPrev(visibleGalleryImages, setVisibleGalleryImages) {
  if (visibleGalleryImages[0] > 0) {
    const newVisibleImages = visibleGalleryImages.map((idx) => idx - 1);
    setVisibleGalleryImages(newVisibleImages);
  }
}

function navigateGalleryNext(
  visibleGalleryImages,
  setVisibleGalleryImages,
  images
) {
  if (
    visibleGalleryImages[visibleGalleryImages.length - 1] <
    images.length - 1
  ) {
    const newVisibleImages = visibleGalleryImages.map((idx) => idx + 1);
    setVisibleGalleryImages(newVisibleImages);
  }
}

function TreatmentNav() {
  const [activeTab, setActiveTab] = useState("LASER HAIR REMOVAL");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const treatmentPath = pathSegments[pathSegments.length - 1];
    
    const currentTreatment = Object.entries(treatmentUrlMap).find(
      ([name, url]) => url.includes(treatmentPath)
    );
    
    if (currentTreatment) {
      setActiveTab(currentTreatment[0]);
    }
  }, [location.pathname]);

  const renderTreatmentIcon = (name) => {
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={name}
        style={{ width: "100px", height: "100px" }}
      />
    ) : null;
  };

  const handleCardClick = (name) => {
    setActiveTab(name);
    navigate(treatmentUrlMap[name]);
  };

  return (
    <div className="ads-treatment-nav-container">
      <h2>Innovative Laser Hair Removal Solutions</h2>
      <div className="ads-treatment-nav-cards">
        {treatments.map(({ name }) => (
          <div
            key={name}
            className={`ads-treatment-nav-card ${activeTab === name ? "active" : ""}`}
            onClick={() => handleCardClick(name)}
          >
            <div className="ads-card-icon">
              {renderTreatmentIcon(name)}
            </div>
            <div className="ads-card-title">{name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Laserhairremoval() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleGalleryImages, setVisibleGalleryImages] = useState([0, 1, 2]);

  // SEO and document setup
  useEffect(() => {
    // Enhanced SEO title with specific location keywords
    document.title =
      "Best Laser Hair Removal Treatment in Chennai, Bangalore | Permanent Hair Reduction Tamil Nadu Karnataka - H-Cura Multispecialty";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Best laser hair removal treatment in Chennai, Bangalore. Advanced permanent hair reduction, diode laser hair removal, and painless hair removal solutions. Professional dermatological services at H-Cura clinic locations across Chennai Tamil Nadu and Bangalore Karnataka including Tambaram, Valasaravakkam, Gerugambakkam, Jayanagar areas."
      );
    }
    
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "laser hair removal Chennai, permanent hair reduction Bangalore, laser hair removal clinic Tamil Nadu, dermatologist Karnataka, diode laser hair removal Chennai Bangalore, laser hair removal specialist Tamil Nadu Karnataka, best laser hair removal clinic Chennai Bangalore, laser hair removal near me, full body laser hair removal Tambaram Valasaravakkam Gerugambakkam Jayanagar, dermatology clinic Chennai Bangalore, facial laser hair removal Tamil Nadu Karnataka, bikini laser hair removal Chennai Bangalore, underarm laser hair removal specialist Chromepet Pallavaram Perungalathur Koramangala BTM Layout JP Nagar, advanced laser hair removal Porur Alwarthirunagar Virugambakkam Banashankari Basavanagudi, painless laser hair removal Kundrathur Mangadu Poonamallee Wilson Garden Lalbagh, laser hair removal for men Chennai Bangalore, laser hair removal for women Tamil Nadu Karnataka, safe laser hair removal Chennai Bangalore, effective laser hair removal Tamil Nadu Karnataka, long lasting hair removal Tambaram Jayanagar, smooth skin laser hair removal Valasaravakkam Koramangala, permanent hair removal Gerugambakkam BTM Layout, unwanted hair removal Chennai Bangalore, professional laser hair removal Tamil Nadu Karnataka, laser hair reduction Chennai Bangalore, laser hair removal services Tamil Nadu Karnataka, laser hair removal doctor Chennai Bangalore, laser hair removal center Tamil Nadu Karnataka, dermatology Chennai Bangalore, laser hair removal clinic Tamil Nadu Karnataka, laser hair removal consultation Chennai Bangalore, laser hair removal skin analysis Tamil Nadu Karnataka, laser hair removal prevention Chennai Bangalore, laser hair removal skin health Tamil Nadu Karnataka, dermatological laser hair removal treatment Chennai Bangalore, cosmetic laser hair removal dermatology Tamil Nadu Karnataka, medical laser hair removal skincare Chennai Bangalore, professional laser hair removal treatment Tamil Nadu Karnataka, laser hair removal skin wellness Chennai Bangalore, laser hair removal dermatology services Tamil Nadu Karnataka, laser hair removal treatment Tambaram Gandhi Road Jayanagar, laser hair removal clinic Valasaravakkam Krishnamachari Nagar Koramangala, laser hair removal dermatologist Gerugambakkam Ramachandra Nagar BTM Layout, laser hair removal doctor Chromepet Pallavaram JP Nagar Banashankari, laser hair removal skin treatment Porur Alwarthirunagar Basavanagudi Wilson Garden, laser hair removal treatment clinic Virugambakkam Kundrathur Lalbagh, laser hair removal rejuvenation treatment Mangadu Poonamallee Bangalore"
      );
    }

    // Add structured data for local business with specific locations
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "H-Cura Multispeciality Clinic",
      "description": "Advanced laser hair removal and permanent hair reduction treatment clinic offering professional dermatological services across Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry",
      "url": "https://www.h-cura.com/advanced-laser-hair-removal-treatment",
      "telephone": "+91 88700 01377",
      "priceRange": "₹₹",
      "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram",
          "addressLocality": "Tambaram",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600045",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "48, 1st Main Rd, Krishnamachari Nagar",
          "addressLocality": "Valasaravakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600116",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony",
          "addressLocality": "Gerugambakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600128",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Jayanagar",
          "addressLocality": "Jayanagar",
          "addressRegion": "Bengaluru, Karnataka",
          "postalCode": "560069",
          "addressCountry": "IN"
        }
      ],
      "areaServed": [
        {
          "@type": "State",
          "name": "Tamil Nadu"
        },
        {
          "@type": "State",
          "name": "Karnataka"
        },
        {
          "@type": "State",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Chennai"
        },
        {
          "@type": "City",
          "name": "Bangalore"
        },
        {
          "@type": "City",
          "name": "Bengaluru"
        },
        {
          "@type": "City",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Puducherry"
        },
        // Chennai Areas
        {
          "@type": "City",
          "name": "Tambaram"
        },
        {
          "@type": "City",
          "name": "Valasaravakkam"
        },
        {
          "@type": "City",
          "name": "Gerugambakkam"
        },
        {
          "@type": "City",
          "name": "Chromepet"
        },
        {
          "@type": "City",
          "name": "Pallavaram"
        },
        {
          "@type": "City",
          "name": "Perungalathur"
        },
        {
          "@type": "City",
          "name": "Porur"
        },
        {
          "@type": "City",
          "name": "Alwarthirunagar"
        },
        {
          "@type": "City",
          "name": "Virugambakkam"
        },
        {
          "@type": "City",
          "name": "Kundrathur"
        },
        {
          "@type": "City",
          "name": "Mangadu"
        },
        {
          "@type": "City",
          "name": "Poonamallee"
        },
        // Bangalore Areas
        {
          "@type": "City",
          "name": "Jayanagar"
        },
        {
          "@type": "City",
          "name": "Koramangala"
        },
        {
          "@type": "City",
          "name": "BTM Layout"
        },
        {
          "@type": "City",
          "name": "JP Nagar"
        },
        {
          "@type": "City",
          "name": "Banashankari"
        },
        {
          "@type": "City",
          "name": "Basavanagudi"
        },
        {
          "@type": "City",
          "name": "Wilson Garden"
        },
        {
          "@type": "City",
          "name": "Lalbagh"
        }
      ],
      "serviceArea": [
        // Tamil Nadu - Chennai Areas
        "Chennai", "Tamil Nadu", "Tambaram", "Valasaravakkam", "Gerugambakkam", "Chromepet", "Pallavaram", "Perungalathur",
        "Porur", "Alwarthirunagar", "Virugambakkam", "Kundrathur", "Mangadu", "Poonamallee", "Gandhi Road", "Krishnamachari Nagar", "Ramachandra Nagar",
        
        // Karnataka - Bangalore Areas
        "Bangalore", "Bengaluru", "Karnataka", "Jayanagar", "Koramangala", "BTM Layout", "JP Nagar", "Banashankari", "Basavanagudi", "Wilson Garden", "Lalbagh"
      ],
      "medicalSpecialty": [
        "Dermatology",
        "Cosmetic Dermatology", 
        "Laser Hair Removal",
        "Permanent Hair Reduction",
        "Diode Laser Hair Removal",
        "Painless Laser Hair Removal",
        "Facial Hair Removal",
        "Body Hair Removal"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Laser Hair Removal Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Advanced Laser Hair Removal"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Full Body Laser Hair Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Diode Laser Hair Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Painless Laser Hair Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Facial Laser Hair Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Bikini Laser Hair Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Underarm Laser Hair Removal"
            }
          }
        ]
      },
      "openingHours": "Mo-Su 10:00-20:00",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1250"
      },
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Priya Sharma"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Excellent laser hair removal treatment at H-Cura Jayanagar. Professional staff and amazing results."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Rajesh Kumar"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Best permanent hair reduction treatment in Chennai Tambaram. Highly recommend H-Cura clinic."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Meera Nair"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Amazing laser hair removal results at H-Cura. Professional and caring staff."
        }
      ]
    };

    // Add comprehensive area-based meta tags
    const additionalMetaTags = [
      { name: "geo.region", content: "IN-TN" },
      { name: "geo.region", content: "IN-KA" },
      { name: "geo.region", content: "IN-PY" },
      { name: "geo.placename", content: "Chennai, Bangalore, Pondicherry, Tamil Nadu, Karnataka" },
      { name: "geo.position", content: "13.0827;80.2707" }, // Chennai coordinates
      { name: "geo.position", content: "12.9716;77.5946" }, // Bangalore coordinates
      { name: "geo.position", content: "11.9416;79.8083" }, // Pondicherry coordinates
      { name: "ICBM", content: "13.0827, 80.2707" },
      { name: "ICBM", content: "12.9716, 77.5946" },
      { name: "ICBM", content: "11.9416, 79.8083" },
      { property: "og:title", content: "Best Laser Hair Removal Treatment Chennai Bangalore Pondicherry | H-Cura Multispecialty Clinic" },
      { property: "og:description", content: "Advanced laser hair removal treatment and permanent hair reduction solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry. Professional dermatological services for smooth, hair-free skin at H-Cura clinics across 100+ locations." },
      { property: "og:url", content: "https://www.h-cura.com/advanced-laser-hair-removal-treatment" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
      { property: "og:site_name", content: "H-Cura Multispecialty Clinic" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Best Laser Hair Removal Treatment Chennai Bangalore Pondicherry | H-Cura" },
      { name: "twitter:description", content: "Advanced laser hair removal treatment and permanent hair reduction solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry." },
      { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" },
      { name: "googlebot", content: "index, follow" },
      { name: "bingbot", content: "index, follow" },
      { name: "language", content: "English" },
      { name: "distribution", content: "global" },
      { name: "rating", content: "general" },
      { name: "revisit-after", content: "7 days" },
      { name: "author", content: "H-Cura Multispecialty Clinic" },
      { name: "classification", content: "Medical, Healthcare, Dermatology" },
      { name: "coverage", content: "Worldwide" },
      { name: "subject", content: "Laser Hair Removal, Permanent Hair Reduction, Dermatology" },
      { name: "copyright", content: "H-Cura Multispecialty Clinic" },
      { name: "locality", content: "Chennai, Bangalore, Pondicherry" },
      { name: "region", content: "Tamil Nadu, Karnataka, Pondicherry" },
      { name: "country", content: "India" }
    ];

    additionalMetaTags.forEach(tag => {
      const existingTag = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="${tag.name || tag.property}"]`);
      if (existingTag) {
        existingTag.setAttribute("content", tag.content);
      } else {
        const metaTag = document.createElement("meta");
        if (tag.name) metaTag.setAttribute("name", tag.name);
        if (tag.property) metaTag.setAttribute("property", tag.property);
        metaTag.setAttribute("content", tag.content);
        document.head.appendChild(metaTag);
      }
    });

    // Add structured data script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-laser-hair-removal-treatment"
      );
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-laser-hair-removal-treatment"
      );
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Add breadcrumb structured data
    const breadcrumbData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.h-cura.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Treatments",
          "item": "https://www.h-cura.com/treatments"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Laser Hair Removal Treatment",
          "item": "https://www.h-cura.com/advanced-laser-hair-removal-treatment"
        }
      ]
    };

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify(breadcrumbData);
    document.head.appendChild(breadcrumbScript);

    // Add FAQ structured data
    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What areas does H-Cura serve for laser hair removal treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "H-Cura provides laser hair removal treatment services across Chennai Tamil Nadu (100+ areas including Tambaram, Valasaravakkam, T Nagar, Anna Nagar), Bangalore Karnataka (100+ areas including Jayanagar, Koramangala, BTM Layout, Indiranagar), and Pondicherry (50+ areas including White Town, Lawspet, Auroville)."
          }
        },
        {
          "@type": "Question",
          "name": "What types of laser hair removal treatments are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer Advanced Laser Hair Removal, Full Body Laser Hair Removal, Diode Laser Hair Removal, Painless Laser Hair Removal, Facial Laser Hair Removal, Bikini Laser Hair Removal, and Underarm Laser Hair Removal across all our Chennai, Bangalore, and Pondicherry locations."
          }
        },
        {
          "@type": "Question",
          "name": "How can I book an appointment for laser hair removal treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can book an appointment by calling +91 88700 01377 or visiting any of our clinics in Chennai (Tambaram, Valasaravakkam, Gerugambakkam), Bangalore (Jayanagar), or Pondicherry locations. We are open Monday to Sunday: 10:00 AM - 8:00 PM."
          }
        },
        {
          "@type": "Question",
          "name": "Is laser hair removal permanent?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Laser hair removal offers permanent hair reduction. While it significantly reduces hair growth, some maintenance sessions might be required over time to address any new hair growth."
          }
        },
        {
          "@type": "Question",
          "name": "Is laser hair removal painful?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Our advanced laser hair removal technology is designed to minimize discomfort. Most clients describe the sensation as a mild prickling or snapping feeling. We prioritize a comfortable experience for all our patients."
          }
        },
        {
          "@type": "Question",
          "name": "How many sessions are typically needed for laser hair removal?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The number of sessions varies depending on hair type, skin type, and the area being treated. Typically, 6-8 sessions are recommended for optimal results, with touch-up sessions as needed. Our specialists will create a personalized treatment plan for you."
          }
        }
      ]
    };

    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.textContent = JSON.stringify(faqData);
    document.head.appendChild(faqScript);

    // Add preconnect for performance
    const performanceLinks = [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "" },
      { rel: "preconnect", href: "https://images.unsplash.com" },
      { rel: "dns-prefetch", href: "https://www.google-analytics.com" },
      { rel: "dns-prefetch", href: "https://www.googletagmanager.com" },
      { rel: "dns-prefetch", href: "https://maps.googleapis.com" },
      { rel: "dns-prefetch", href: "https://fonts.googleapis.com" },
      { rel: "dns-prefetch", href: "https://cdnjs.cloudflare.com" }
    ];

    performanceLinks.forEach(link => {
      const existingLink = document.querySelector(`link[href="${link.href}"]`);
      if (!existingLink) {
        const linkElement = document.createElement("link");
        linkElement.setAttribute("rel", link.rel);
        linkElement.setAttribute("href", link.href);
        if (link.crossorigin !== undefined) {
          linkElement.setAttribute("crossorigin", link.crossorigin);
        }
        document.head.appendChild(linkElement);
      }
    });

    // Add hreflang tags for regional targeting
    const hreflangTags = [
      { rel: "alternate", hreflang: "en-IN", href: "https://www.h-cura.com/advanced-laser-hair-removal-treatment" },
      { rel: "alternate", hreflang: "en", href: "https://www.h-cura.com/advanced-laser-hair-removal-treatment" }
    ];

    hreflangTags.forEach(tag => {
      const existingHreflang = document.querySelector(`link[hreflang="${tag.hreflang}"]`);
      if (!existingHreflang) {
        const hreflangLink = document.createElement("link");
        hreflangLink.setAttribute("rel", tag.rel);
        hreflangLink.setAttribute("hreflang", tag.hreflang);
        hreflangLink.setAttribute("href", tag.href);
        document.head.appendChild(hreflangLink);
      }
    });

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.textContent.includes('H-Cura Multispeciality Clinic')) {
          script.remove();
        }
      });
    };
  }, []);

  useEffect(() => {
    const steps = document.querySelectorAll(".ads-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  const openModal = (image) => {
    const index = images.findIndex(img => img.src === image.src);
    setCurrentImageIndex(index);
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  const navigatePrevious = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateNext = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  // Define process steps array
  const processSteps = [
    {
      step: "01",
      title: "In-Depth Consultation",
      desc: "Kick off your journey with a thorough consultation to assess your hair and skin type for laser hair removal.",
      details: [
        "Detailed hair and skin analysis",
        "Personal health review",
        "Customized treatment roadmap",
        "Expectation setting",
      ],
      icon: "🔍",
    },
    {
      step: "02",
      title: "Tailored Treatment Planning",
      desc: "Our specialists design a personalized laser hair removal plan just for you, targeting specific areas.",
      details: [
        "Individualized regimen design",
        "Session scheduling",
        "Pre-treatment care instructions",
      ],
      icon: "📋",
    },
    {
      step: "03",
      title: "Expert Laser Session",
      desc: "Experience our precise techniques for targeted and effective laser hair removal.",
      details: [
        "Sterile preparation",
        "Advanced laser application",
        "Comfort-focused procedure",
        "Targeted hair follicle treatment",
      ],
      icon: "💉",
    },
    {
      step: "04",
      title: "Comprehensive Aftercare",
      desc: "Benefit from our dedicated follow-up care ensuring your skin remains smooth and hair-free.",
      details: [
        "Routine progress reviews",
        "Adaptive treatment adjustments",
        "Maintenance plans",
        "Long-term support",
      ],
      icon: "📈",
    },
  ];

  // Define benefits array
  const benefits = [
    {
      icon: "🔬",
      title: "State-of-the-Art Technology",
      desc: "We deploy the latest in laser hair removal technology for precise and effective results.",
      features: [
        "Advanced Diode Laser",
        "FDA-approved methods",
        "Clinically proven outcomes",
      ],
    },
    {
      icon: "👨‍⚕️",
      title: "Expert Medical Team",
      desc: "Our board-certified specialists provide personalized care tailored to your hair removal needs.",
      features: [
        "Highly experienced professionals",
        "Individual consultations",
        "Focused attention to detail",
      ],
    },
    {
      icon: "🎯",
      title: "Customized Therapy",
      desc: "Every treatment plan is designed specifically for your hair and skin type, and target areas.",
      features: [
        "Tailored sessions",
        "Ongoing progress monitoring",
        "Optimized treatment frequency",
      ],
    },
    {
      icon: "✨",
      title: "Long-Lasting Smoothness",
      desc: "Achieve permanent hair reduction and visibly smoother skin with our effective treatments.",
      features: [
        "Significant hair reduction",
        "Smooth, clear skin",
        "Reduced ingrown hairs",
      ],
    },
    {
      icon: "🛡️",
      title: "Safety First",
      desc: "We maintain the highest standards of safety and hygiene in our laser hair removal facilities.",
      features: [
        "Medical-grade environment",
        "Strict protocols",
        "Patient-centric care",
      ],
    },
    {
      icon: "💯",
      title: "Proven Success",
      desc: "Join thousands of happy clients who have achieved hair-free skin with our solutions.",
      features: [
        "Over 5000 satisfied clients",
        "Remarkable clinical outcomes",
        "Consistently high success rates",
      ],
    },
  ];

  return (
    <div className="ads-wrapper">
      <TreatmentNav />
      <section
        className="ads-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`,
        }}
      >
        <div className="ads-hero-content">
          <h1 className="ads-hero-title">
            Innovative Laser Hair Removal Solutions for Smooth Skin
          </h1>
          <p className="ads-hero-text">
            Experience cutting-edge laser hair removal therapies designed to
            provide long-lasting hair reduction and smooth skin.
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none" }}
            className="ads-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      <section className="ads-treatment-section" id="treatments">
        <div className="ads-treatment-container">
          <div className="ads-treatment-nav">
            <h2>Revitalize Your Skin with Laser Hair Removal</h2>
            <p className="ads-nav-description">
              Our laser hair removal treatment combines advanced technology with
              expert techniques for optimal hair reduction and skin health.
            </p>

            <ul className="ads-treatment-list">
              <li className="ads-treatment-item">
                <strong>FULL BODY LASER HAIR REMOVAL</strong>
                <p>Comprehensive treatment for all body areas.</p>
                <ul className="ads-treatment-details">
                  <li>Smooth, Hair-Free Skin</li>
                  <li>Reduces Ingrown Hairs</li>
                  <li>Long-Lasting Results</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>DIODE LASER HAIR REMOVAL</strong>
                <p>Advanced diode laser for effective hair reduction.</p>
                <ul className="ads-treatment-details">
                  <li>Suitable for Various Skin Types</li>
                  <li>Fast and Efficient Sessions</li>
                  <li>Minimizes Hair Regrowth</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>PAINLESS LASER HAIR REMOVAL</strong>
                <p>Comfort-focused treatment with minimal discomfort.</p>
                <ul className="ads-treatment-details">
                  <li>Gentle on the Skin</li>
                  <li>Effective Hair Reduction</li>
                  <li>Comfortable Experience</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>FACIAL LASER HAIR REMOVAL</strong>
                <p>Precision treatment for unwanted facial hair.</p>
                <ul className="ads-treatment-details">
                  <li>Removes Upper Lip Hair</li>
                  <li>Treats Chin and Jawline Hair</li>
                  <li>Smooths Facial Skin</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>BIKINI & UNDERARM LASER HAIR REMOVAL</strong>
                <p>Targeted treatment for sensitive areas.</p>
                <ul className="ads-treatment-details">
                  <li>Reduces Hair in Sensitive Zones</li>
                  <li>Prevents Razor Bumps</li>
                  <li>Provides Confidence</li>
                </ul>
              </li>
            </ul>

            <p className="ads-treatment-description-text">
              Our Laser Hair Removal treatments are customized for each individual's
              skin type and hair removal goals.
            </p>
            <p className="ads-treatment-extra-info">
              Book a consultation today to discover the benefits of
              laser hair removal.
            </p>
          </div>

          <div className="ads-treatment-content">
            <h3>Innovative Laser Hair Removal Treatment Overview</h3>
            <div className="ads-treatment-info">
              <div className="ads-treatment-images">
                <img
                  src={heroImage1}
                  alt="Innovative Laser Hair Removal Treatment Process"
                  className="ads-main-treatment-image"
                />
                <div className="ads-gallery-container">
                  {/* Gallery navigation buttons for smaller screens */}
                  <button 
                    className="ads-gallery-nav ads-gallery-prev ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: -gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      // For larger screens, update visible images state
                      if (visibleGalleryImages[0] > 0) {
                        setVisibleGalleryImages(visibleGalleryImages.map(idx => idx - 1));
                      }
                    }}
                    aria-label="Previous image"
                    style={{display: visibleGalleryImages[0] > 0 ? 'block' : 'none'}}
                  >
                    &#10094;
                  </button>
                  <button 
                    className="ads-gallery-nav ads-gallery-next ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      // For larger screens, update visible images state
                      if (visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1) {
                        setVisibleGalleryImages(visibleGalleryImages.map(idx => idx + 1));
                      }
                    }}
                    aria-label="Next image"
                    style={{display: visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1 ? 'block' : 'none'}}
                  >
                    &#10095;
                  </button>
                </div>
                <div className="ads-gallery-dots">
                  {images.map((_, index) => (
                    <span
                      key={index}
                      className={`ads-gallery-dot ${visibleGalleryImages.includes(index) ? 'active' : ''}`}
                      onClick={() => {
                        const start = Math.max(0, index - 1);
                        const end = Math.min(images.length - 1, index + 1);
                        const newVisible = [];
                        for (let i = start; i <= end; i++) {
                          newVisible.push(i);
                        }
                        setVisibleGalleryImages(newVisible);
                      }}
                    ></span>
                  ))}
                </div>
              </div>

              <div className="ads-treatment-description">
                <h4>Empowering Innovative Laser Hair Removal Solutions</h4>
                <div className="ads-treatment-intro">
                  <span className="ads-highlight-tag">
                     INNOVATIVE LASER HAIR REMOVAL
                  </span>
                  <p className="ads-lead-text">
                    Our breakthrough laser hair removal treatments combine advanced
                    technology and expert care to provide long-lasting smoothness.
                  </p>
                </div>

                <div className="ads-key-benefits">
                  <h5>Transformative Benefits of Our Treatments</h5>
                  <p>Enjoy benefits such as:</p>
                  <ul>
                    <li>
                      <span className="ads-benefit-icon">
                        <img src={nonInvasiveIcon} alt="Long Term Reduction" />
                      </span>{" "}
                      <strong>Long-Term Reduction</strong>
                      <p>Effective and permanent hair reduction for smooth skin</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={enhancedHydrationIcon}
                          alt="Cost Effectiveness"
                        />
                      </span>{" "}
                      <strong>Cost-Effectiveness</strong>
                      <p>Money-saving and time-efficient compared to other methods</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={skinRenewalIcon}
                          alt="Reduced Risk of Skin Irritation"
                        />
                      </span>{" "}
                      <strong>Reduced Risk of Skin Irritation</strong>
                      <p>Less chances of irritation, redness, and ingrown hairs</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={deepCleansingIcon}
                          alt="Non-Invasive Treatment"
                        />
                      </span>{" "}
                      <strong>Non-Invasive Treatment</strong>
                      <p>
                        Achieve noticeable results without any downtime or
                        discomfort.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="ads-treatment-highlights">
                  <div className="ads-highlight-box">
                    <h5>Client Satisfaction Rate</h5>
                    <p>98%</p>
                    <span className="ads-subtitle">Happy Clients</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Session Duration</h5>
                    <p>45 mins</p>
                    <span className="ads-subtitle">
                      Per Treatment
                    </span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Minimal Downtime</h5>
                    <p>Immediate Results</p>
                    <span className="ads-subtitle">
                      Quick Recovery
                    </span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="ads-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="ads-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ads-benefits-section">
        <div className="ads-benefits-header">
          <span className="ads-section-tag">Why Choose Us</span>
          <h2>Experience Excellence with H-Cura Multispeciality clinic</h2>
          <p className="ads-section-subtitle">
            Our advanced laser hair removal treatments combine clinical expertise with innovative
            technology to provide safe and effective permanent hair reduction.
          </p>
        </div>
        <div className="ads-benefits-grid">
          {benefits && benefits.map((benefit, index) => (
            <div className="ads-benefit-card" key={index}>
              <div className="ads-benefit-icon">{benefit.icon}</div>
              <div className="ads-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="ads-feature-list">
                  {benefit.features && benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="ads-process-section" id="process">
        <div className="ads-process-header">
          <span className="ads-process-tag">Our Process</span>
          <h2>Your Journey to Smooth, Hair-Free Skin</h2>
          <p className="ads-process-subtitle">
            Follow our comprehensive 4-step approach for sustainable laser
            hair removal and skin wellness.
          </p>
        </div>
        <div className="ads-process-timeline">
          {processSteps && processSteps.map((process, index) => (
            <div className="ads-process-step" key={index}>
              <div className="ads-step-container">
                <div className="ads-step-number-container">
                  <div className="ads-step-number">{process.step}</div>
                  <div className="ads-step-icon">{process.icon}</div>
                </div>
                <div className="ads-step-content">
                  <h3>{process.title}</h3>
                  <p className="ads-step-description">
                    {process.desc}
                  </p>
                  <ul className="ads-step-details">
                    {process.details && process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < 3 && <div className="ads-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>

      {/* Hidden SEO Content - Not visible to users but crawlable by search engines */}
      <div style={{ display: 'none' }}>
        <h2>Best Laser Hair Removal Treatment Services in Chennai Tamil Nadu and Bangalore Karnataka - H-Cura Locations</h2>
        
        <h3>Laser Hair Removal Treatment in Tambaram Chennai - Gandhi Road Location</h3>
        <p>
          Advanced laser hair removal treatment services at our Tambaram clinic located at Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Chennai, Tamil Nadu 600045. 
          Serving patients from Chromepet, Pallavaram, Perungalathur areas with Full Body Laser Hair Removal, Diode Laser Hair Removal, Permanent Hair Reduction, Painless Laser Hair Removal. 
          Specializing in Laser Hair Removal & Skin Treatment. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best laser hair removal treatment Tamil Nadu, laser hair removal specialist Chennai, laser hair removal dermatologist Tambaram, laser hair removal clinic Chromepet, laser hair removal treatment Pallavaram, full body laser hair removal Perungalathur.
        </p>
        
        <h3>Laser Hair Removal Clinic in Valasaravakkam Chennai - Krishnamachari Nagar</h3>
        <p>
          Professional laser hair removal services at our Valasaravakkam branch located at 48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116. 
          Serving Porur, Alwarthirunagar, Virugambakkam communities with Facial Laser Hair Removal, Bikini Laser Hair Removal, Underarm Laser Hair Removal, Legs Laser Hair Removal. 
          Specializing in Laser Hair Removal & Skin Care. Phone: +91 88700 01377. Hours: Monday to Sunday: 10:00 AM - 8:00 PM.
          Laser hair removal treatment Valasaravakkam, laser hair removal clinic Porur, laser hair removal dermatologist Alwarthirunagar, laser hair removal specialist Virugambakkam, laser hair removal for face Chennai Tamil Nadu.
        </p>
        
        <h3>Complete Laser Hair Removal Solutions in Gerugambakkam Chennai - Ramachandra Nagar</h3>
        <p>
          Comprehensive laser hair removal treatment services at our Gerugambakkam clinic at Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128. 
          Providing services to Kundrathur, Mangadu, Poonamallee residents with Laser Hair Removal for Men, Laser Hair Removal for Women, Safe Laser Hair Removal, Effective Laser Hair Removal. 
          Offering Complete Laser Hair Removal Solutions. Call: +91 88700 01377. Timing: Monday to Sunday: 10:00 AM - 8:00 PM.
          Laser hair removal treatment Gerugambakkam, laser hair removal clinic Kundrathur, laser hair removal dermatologist Mangadu, laser hair removal specialist Poonamallee, laser hair removal for body Chennai Tamil Nadu.
        </p>

        <h3>Advanced Laser Hair Removal Treatment in Jayanagar Bangalore Karnataka</h3>
        <p>
          Premier laser hair removal and permanent hair reduction services at our Jayanagar Bangalore clinic located at Jayanagar, Bengaluru, Karnataka 560069. 
          Serving patients from Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh areas with Advanced Laser Hair Removal, Laser Hair Removal for Body, Laser Hair Removal for Face, Long Lasting Hair Removal. 
          Specializing in Advanced Laser Hair Removal & Dermatology Treatments. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best laser hair removal treatment Bangalore, laser hair removal specialist Karnataka, laser hair removal dermatologist Jayanagar, laser hair removal clinic Koramangala, laser hair removal treatment BTM Layout, diode laser hair removal JP Nagar, 
          laser hair removal doctor Banashankari, laser hair removal for men Basavanagudi, laser hair removal dermatology Wilson Garden, laser hair removal treatment Lalbagh, laser hair removal clinic Bangalore Karnataka, laser hair removal specialist Bengaluru.
        </p>

        <h3>Comprehensive Bangalore Karnataka Service Areas</h3>
        <p>
          H-Cura Multispeciality Clinic Bangalore provides laser hair removal treatment and permanent hair reduction services across Bangalore Karnataka including Jayanagar, Koramangala, BTM Layout, JP Nagar, 
          Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout, Marathahalli, Bannerghatta Road, Hebbal, Yeshwantpur,
          Rajajinagar, Malleshwaram, Sadashivanagar, RT Nagar, Yelahanka, Kengeri, Vijayanagar, Nagarbhavi areas in Karnataka.
          Laser hair removal treatment Bangalore, permanent hair reduction Karnataka, laser hair removal dermatologist Bengaluru, laser hair removal clinic Bangalore, laser hair removal specialist Karnataka, full body laser hair removal Bangalore, 
          diode laser hair removal Karnataka, painless laser hair removal Bangalore, facial laser hair removal Karnataka, bikini laser hair removal Bangalore, underarm laser hair removal Karnataka.
        </p>

        <h3>Chennai Tamil Nadu Service Areas Coverage</h3>
        <p>
          H-Cura Multispeciality Clinic Chennai provides laser hair removal treatment and permanent hair reduction services across Chennai Tamil Nadu including Tambaram East, Tambaram West, Chromepet, Pallavaram, 
          Perungalathur, Selaiyur, Chitlapakkam, Valasaravakkam, Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam, Gerugambakkam, Kundrathur, 
          Mangadu, Poonamallee, Nazarethpet, Thirumazhisai areas in Tamil Nadu.
          Laser hair removal treatment Chennai, permanent hair reduction Tamil Nadu, laser hair removal dermatologist Chennai, laser hair removal clinic Tamil Nadu, laser hair removal specialist Chennai, full body laser hair removal Tamil Nadu.
        </p>

        <h3>Advanced Laser Hair Removal Treatments Available Across Chennai Tamil Nadu and Bangalore Karnataka</h3>
        <p>
          Our Chennai Tamil Nadu and Bangalore Karnataka locations offer comprehensive laser hair removal treatment including Advanced Laser Hair Removal, Full Body Laser Hair Removal, Diode Laser Hair Removal, 
          Painless Laser Hair Removal, Facial Laser Hair Removal, Bikini Laser Hair Removal, Underarm Laser Hair Removal, 
          Laser Hair Removal for Men, and Laser Hair Removal for Women.
          Best laser hair removal treatment Chennai Bangalore, laser hair removal specialist Tamil Nadu Karnataka, laser hair removal dermatologist Chennai Bangalore, laser hair removal clinic Tamil Nadu Karnataka.
        </p>

        <h3>Expert Laser Hair Removal Dermatology Team Chennai Tamil Nadu Bangalore Karnataka</h3>
        <p>
          Board-certified laser hair removal dermatologists and specialists providing personalized laser hair removal treatment solutions across Tambaram Gandhi Road Chennai, 
          Valasaravakkam Krishnamachari Nagar Chennai, Gerugambakkam Ramachandra Nagar Chennai, and Jayanagar Bangalore locations in Tamil Nadu and Karnataka.
          Laser hair removal specialist Chennai Bangalore, laser hair removal dermatologist Tamil Nadu Karnataka, laser hair removal doctor Chennai Bangalore, laser hair removal treatment expert Tamil Nadu Karnataka.
        </p>

        <h3>SEO Keywords for Google Ranking</h3>
        <p>
          laser hair removal near me, permanent hair reduction near me, dermatologist near me, laser hair removal clinic near me, full body laser hair removal near me, best laser hair removal treatment, 
          professional laser hair removal, laser hair removal doctor, laser hair removal skin clinic, laser hair removal dermatology clinic, diode laser hair removal, painless laser hair removal, facial laser hair removal, 
          bikini laser hair removal, underarm laser hair removal, laser hair removal for men, laser hair removal for women, safe laser hair removal, effective laser hair removal, long lasting hair removal, 
          smooth skin laser hair removal, unwanted hair removal, laser hair reduction, laser hair removal services, laser hair removal consultation, laser hair removal skin analysis, laser hair removal treatment prevention, dermatological laser hair removal treatment, 
          laser hair removal skin wellness, laser hair removal therapy, laser hair removal skin problem solutions, laser hair removal for body, laser hair removal for face, 
          laser hair removal specialist doctor, professional laser hair removal care, advanced laser hair removal treatment, innovative laser hair removal solutions, laser hair removal skin transformation, 
          laser hair removal treatment for youthful skin, radiant laser hair removal therapy, laser hair removal skin renewal, laser hair removal management, laser hair removal for all skin types, 
          non-invasive laser hair removal treatment, safe laser hair removal treatment, effective laser hair removal care, proven laser hair removal solutions, personalized laser hair removal treatment, 
          customized laser hair removal therapy, expert laser hair removal care, quality laser hair removal dermatology services, trusted laser hair removal clinic, reliable laser hair removal treatment, 
          affordable laser hair removal care, convenient laser hair removal dermatology, accessible laser hair removal treatment, comprehensive laser hair removal solutions.
        </p>
      </div>

      {/* Modal for Image Viewing with Navigation */}
      {isModalOpen && modalImage && (
        <div className="ads-modal-overlay" onClick={closeModal}>
          <div className="ads-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ads-close-modal" onClick={closeModal}>
              &times;
            </button>
            <button
              className="ads-modal-nav ads-modal-prev"
              onClick={navigatePrevious}
            >
              &#10094;
            </button>
            <img
              src={modalImage.src}
              alt={modalImage.alt}
              className="ads-modal-image"
            />
            <button
              className="ads-modal-nav ads-modal-next"
              onClick={navigateNext}
            >
              &#10095;
            </button>
            <div className="ads-modal-counter">
              {currentImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Laserhairremoval;
